module.exports = __webpack_public_path__ + "static/media/logo1.9cf17284.jpeg";